import React, { useEffect, useState } from 'react';
import './Marquee.css';
import axios from 'axios';

const config = require("../../config.json");


const FlashNews = () => {
  /*const messages = [
    "🚀 Flash Sale: 50% off all courses!",
    "🛠️ New Update: React 19 support added.",
    "🌐 Join our global developer community.",
    "🎁 Referral rewards are now active!"
  ];*/
  const [activePost, setActivePost] = useState([]);

  useEffect(() => {
    fetchFlashNews();
  }, []);

   const fetchFlashNews =async()=>{
        try{
          //  setLoaded(false);
          // const { idToken } = (await fetchAuthSession()).tokens ?? {};
            const startDate=await generateDate();
            const clientID="SMCMDU";
            var searchOption="ActiveFlashNews";
            var searchFilter="Active";
           
        await axios.get(`${config.api.invokeUrl}/website/infodesk?clientID=${clientID}&startDate=${startDate}&searchOption=${searchOption}&searchFilter=${searchFilter}`,{
            headers: {
             // Authorization: idToken,
              'x-api-key': config.api.key
            }}, 
        ).then((response)=>{
            console.log(response);
            setActivePost(response.data);
           // setGalleryImages(response.data);
          // enqueueSnackbar(response.data.length + " - " + searchFilter + " Messages available", {variant:'success'}); 
          //  setLoaded(true);
            //setDispMsg(response.data.length + " - Images are found in your Gallery");
        }).catch((error)=>{
          //  enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
         //   setLoaded(true);
        })
    }catch(error){
		//console.log(error);
       // enqueueSnackbar("Error Occured - " + error.message,{variant:'warning'}); 
       // setLoaded(true);
        //setDispMsg(error.message);
    }
    }

        const generateDate = async () => {
        const current_datetime = new Date();
        const date_year = (current_datetime.getFullYear()).toString();
        var date_month = (current_datetime.getMonth() + 1).toString();
        var month_value="";
        date_month.length===1? (month_value=month_value.concat(0,date_month)):(month_value=date_month);
        var date_date = (current_datetime.getDate().toString());
        var date_value="";
        date_date.length===1?(date_value=date_value.toString().concat(0,date_date)):(date_value=date_date);
        var date_hours = (current_datetime.getHours().toString());
        var hours_value="";
        date_hours.length===1?(hours_value=hours_value.toString().concat(0,date_hours)):(hours_value=date_hours);
        var date_minutes = (current_datetime.getMinutes().toString());
        var minutes_value="";
        date_minutes.length===1 ?(minutes_value=minutes_value.toString().concat(0,date_minutes)):(minutes_value=date_minutes);
        var todayDate="";
        const tDate = todayDate.concat(date_year,"-",month_value,"-", date_value);
        //setUserId(accountNo);
        return tDate;
        //console.log("acc : ", accountNo);
    }    
return (
  <div style={{zIndex:999999}}>
      <div className="news-ticker-container">
        
        {/* Fixed Label */}
        <div className="ticker-label">
          <span className="icon">📢</span>
          <span className="label-text">Announcements</span>
        </div>

        {/* Scrolling Area */}
        <div className="ticker-window">
          <div className="ticker-track">
            {activePost.map((m, i) => (
              <span key={i} className="ticker-item"><i className="fas fa-bullhorn me-2 "></i>{"  "}{m.flashNews.message}</span>
            ))}
            {/* We repeat the array once to ensure no gap during the transition */}
            {activePost.map((m, i) => (
              <span key={`dup-${i}`} className="ticker-item" aria-hidden="true"><i className="fas fa-bullhorn me-2 "></i>{"  "}{m.flashNews.message}</span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlashNews;